import Draw from 'ol/interaction/Draw';
import Overlay from 'ol/Overlay';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
import { LineString, Polygon } from 'ol/geom';
import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import { getArea, getLength } from 'ol/sphere';
import { unByKey } from 'ol/Observable';

const sourceMeasure = new VectorSource();
const vectorMeasure = new VectorLayer({
  title: 'Ölçüm Katmanı',
  source: sourceMeasure,
  style: new Style({
    fill: new Fill({
      color: 'rgba(255, 255, 255, 0.2)',
    }),
    stroke: new Stroke({
      color: '#ffcc33',
      width: 2,
    }),
    image: new CircleStyle({
      radius: 7,
      fill: new Fill({
        color: '#ffcc33',
      }),
    }),
  }),
});

let sketch;
let helpTooltipElement;
let helpTooltip;
let measureTooltipElement;
let measureTooltip;
const continuePolygonMsg = 'Çokgen çizmeye devam etmek için tıklayınız';
const continueLineMsg = 'Uzunluk ölçmeye devam etmek için tıklayınız';

const pointerMoveHandler = function (evt) {
  if (evt.dragging) {
    return;
  }
  let helpMsg = 'Ölçmeye başlamak için tıklayınız';

  if (sketch) {
    const geom = sketch.getGeometry();
    if (geom instanceof Polygon) {
      helpMsg = continuePolygonMsg;
    } else if (geom instanceof LineString) {
      helpMsg = continueLineMsg;
    }
  }

  helpTooltipElement.innerHTML = helpMsg;
  helpTooltip.setPosition(evt.coordinate);

  helpTooltipElement.classList.remove('hidden');
};

//type length,area

let drawMeasure;

const formatLength = function (line) {
  const length = getLength(line, {
    projection: 'EPSG:32637',
  });
  let output;
  /*   if (length > 1000) {
    output = Math.round(length / 1000) + ' ' + 'km';
  } else {
    output = Math.round(length) + ' ' + 'm';
  } */
  output = Math.round(length) + ' ' + 'm';
  return output;
};

const formatArea = function (polygon) {
  const area = getArea(polygon, {
    projection: 'EPSG:32637',
  });
  let output;
  /*   if (area > 10000) {
    output = (area / 1000000).toFixed(2) + ' ' + 'km²';
  } else {
    output = area.toFixed(2) + ' ' + 'm²';
  } */
  output = area.toFixed(2) + ' ' + 'm²';
  return output;
};

function startMeasure(map, type) {
  //const type = typeSelect.value == 'area' ? 'Polygon' : 'LineString';
  map.removeInteraction(drawMeasure);
  
  // Ölçüm katmanının haritada olup olmadığını kontrol et, yoksa ekle
  const isLayerOnMap = map.getLayers().getArray().some(layer => 
    layer === vectorMeasure
  );
  if (!isLayerOnMap) {
    map.addLayer(vectorMeasure);
  }
  
  drawMeasure = new Draw({
    source: sourceMeasure,
    type: type,
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)',
      }),
      stroke: new Stroke({
        color: 'rgba(0, 0, 0, 0.5)',
        lineDash: [10, 10],
        width: 2,
      }),
      image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
          color: 'rgba(0, 0, 0, 0.7)',
        }),
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.2)',
        }),
      }),
    }),
  });
  map.addInteraction(drawMeasure);

  createMeasureTooltip(map);
  createHelpTooltip(map);

  let listener;
  drawMeasure.on('drawstart', function (evt) {
    // set sketch
    sketch = evt.feature;

    let tooltipCoord = evt.coordinate;

    listener = sketch.getGeometry().on('change', function (evt) {
      const geom = evt.target;
      let output;
      if (geom instanceof Polygon) {
        output = formatArea(geom);
        tooltipCoord = geom.getInteriorPoint().getCoordinates();
      } else if (geom instanceof LineString) {
        output = formatLength(geom);
        tooltipCoord = geom.getLastCoordinate();
      }
      measureTooltipElement.innerHTML = output;
      measureTooltip.setPosition(tooltipCoord);
    });
  });

  drawMeasure.on('drawend', function () {
    measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
    measureTooltip.setOffset([0, -7]);
    // unset sketch
    sketch = null;
    // unset tooltip so that a new one can be created
    measureTooltipElement = null;
    createMeasureTooltip(map);
    unByKey(listener);
  });
}

function createHelpTooltip(map) {
  if (helpTooltipElement) {
    helpTooltipElement.parentNode.removeChild(helpTooltipElement);
  }
  helpTooltipElement = document.createElement('div');
  helpTooltipElement.className = 'ol-tooltip hidden';
  helpTooltip = new Overlay({
    element: helpTooltipElement,
    offset: [15, 0],
    positioning: 'center-left',
  });
  map.addOverlay(helpTooltip);
}

function createMeasureTooltip(map) {
  if (measureTooltipElement) {
    measureTooltipElement.parentNode.removeChild(measureTooltipElement);
  }
  measureTooltipElement = document.createElement('div');
  measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
  measureTooltip = new Overlay({
    element: measureTooltipElement,
    offset: [0, -15],
    positioning: 'bottom-center',
    stopEvent: false,
    insertFirst: false,
  });
  map.addOverlay(measureTooltip);
}

export const startMeasureService = (map, type) => {
  return new Promise((resolve, reject) => {
    // Önceki ölçüm interaction'larını ve overlay'lerini temizle
    map.removeInteraction(drawMeasure);
    if (helpTooltip) {
      map.removeOverlay(helpTooltip);
    }
    if (measureTooltip) {
      map.removeOverlay(measureTooltip);
    }
    map.un('pointermove', pointerMoveHandler);
    
    // Yeni ölçüm başlat
    map.on('pointermove', pointerMoveHandler);
    map.getViewport().addEventListener('mouseout', function () {
      helpTooltipElement.classList.add('hidden');
    });
    startMeasure(map, type);
    resolve(vectorMeasure);
  });
};

export const stopMeasureService = (map) => {
  map.removeInteraction(drawMeasure);
  map.removeOverlay(helpTooltip);
  map.removeOverlay(measureTooltip);
};

export const cleanMeasureService = (map) => {
  let elements = document.getElementsByClassName(
    'ol-overlay-container ol-selectable'
  );
  let featuresMeasure = vectorMeasure.getSource().getFeatures();
  featuresMeasure.forEach((featureMeasure) => {
    vectorMeasure.getSource().removeFeature(featureMeasure);
  });
  for (var i = 0; i < elements.length; i++) {
    elements.item(i).remove();
  }
  for (var i = 0; i < elements.length; i++) {
    elements.item(i).remove();
  }
  map.removeOverlay(helpTooltip);
  map.removeOverlay(measureTooltip);
  map.removeInteraction(drawMeasure);
  map.removeLayer(vectorMeasure);
  
  // Pointer event handler'ı temizle
  map.un('pointermove', pointerMoveHandler);
};
